import type {
  MessageResponse,
  NaverPlaceFetchResponse,
  PaginatedPlaces,
  Place,
  PlaceCreate,
  PlaceListParams,
  PlaceScoreHistoryResponse,
  PlaceUpdate,
} from '../types';
import apiClient from './apiClient';

export const placeService = {
  async listPlaces(params: PlaceListParams = {}): Promise<PaginatedPlaces> {
    const response = await apiClient.get<PaginatedPlaces>('/places', { params });
    return response.data;
  },

  async getPlace(placeId: number): Promise<Place> {
    const response = await apiClient.get<Place>(`/places/${placeId}`);
    return response.data;
  },

  async createPlace(data: PlaceCreate): Promise<Place> {
    const response = await apiClient.post<Place>('/places', data);
    return response.data;
  },

  async updatePlace(placeId: number, data: PlaceUpdate): Promise<Place> {
    const response = await apiClient.patch<Place>(`/places/${placeId}`, data);
    return response.data;
  },

  async deletePlace(placeId: number): Promise<MessageResponse> {
    const response = await apiClient.delete<MessageResponse>(`/places/${placeId}`);
    return response.data;
  },

  async getPlaceScoreHistory(
    placeId: number,
    params?: { start_date?: string; end_date?: string; period?: '7d' | '30d' | '90d' }
  ): Promise<PlaceScoreHistoryResponse> {
    const response = await apiClient.get<PlaceScoreHistoryResponse>(
      `/places/${placeId}/score-history`,
      { params }
    );
    return response.data;
  },

  async fetchNaverPlaceData(naverUrl: string): Promise<NaverPlaceFetchResponse> {
    const response = await apiClient.post<NaverPlaceFetchResponse>('/places/fetch-naver', {
      naver_url: naverUrl,
    });
    return response.data;
  },
};
